import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Howl } from 'howler';
import './LightFoodCard.css';
import { buildApiUrl } from '../../config/api.config';

const LightFoodCard = ({ id, name, description, price, image, date, category }) => {
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(!image);

  const clickSound = new Howl({
    src: ['/sounds/click.mp3'],
    volume: 0.5
  });

  const handleViewMore = () => {
    clickSound.play();
    navigate(`/food/${id}`, { 
      state: { name, description, price, image, date, category } 
    });
  };

  return (
    <div className="light-food-card">
      <div className="light-food-card-img-container">
        {imageError ? (
          <div className="light-food-placeholder">
            <i className="fa-solid fa-utensils"></i>
          </div>
        ) : (
          <img
            className="light-food-item-image"
            src={buildApiUrl(`/uploads/${image}`)}
            alt={name}
            onError={() => setImageError(true)}
          />
        )}
      </div>
      <div className="light-food-item-info">
        <div className="light-food-item-header">
          <p className="light-food-item-name">{name}</p>
          <p className="light-food-item-price">₹{price}</p>
        </div>
        {description && (
          <p className="light-food-item-desc">{description}</p>
        )}
        <button className="light-view-more" onClick={handleViewMore}>
          View Details
        </button>
      </div>
    </div>
  );
};

export default LightFoodCard;
